import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";
import {environment} from "./environments/environment";

export class Configurations {
  static buildTestCommonHeader(config: Configurations, contentType: string): HttpHeaders {
    if (config) {
      return new HttpHeaders({
        'Content-Type': (contentType ? contentType : 'application/json'),
        'LoginId': config.testUserId,
        'AccessKey': config.testAccessKey,
        'SecretKey': config.testSecretKey
      });  
    } else {
      return new HttpHeaders({
        'Content-Type': (contentType ? contentType : 'application/json'),
        'LoginId': Configurations.testCommonUserId,
        'AccessKey': Configurations.testCommonAccessKey,
        'SecretKey': Configurations.testCommonSecretKey
      });  
    }
  }
  public static testCommonUserId = environment.commonOptions.testUserId;
  public static testCommonAccessKey = environment.commonOptions.testCommonAccessKey;
  public static testCommonSecretKey = environment.commonOptions.testCommonSecretKey;

  public createTranslateLoader: (client: HttpClient) => MultiTranslateHttpLoader;
  public getProduction: () => boolean;
  public getLoginEndPoint: () => string;
  public getMenuEndPoint?: () => string;

  /**
   * Following is for test purpose only !!!
   */
  public testUserId?: string;
  public testPassword?: string;
  public testAccessKey?: string;
  public testSecretKey?: string;

  constructor() {
    this.createTranslateLoader = null;
    this.getProduction = null;
    this.getLoginEndPoint = null;
  }    
}
